
import { useState, useEffect } from 'react';
import ConfettiEffect from '@/components/ConfettiEffect';
import AppPreviewMockups from '@/components/AppPreviewMockups';
import DemandIndicatorsSection from '@/components/landing/DemandIndicatorsSection';
import StickyNotification from '@/components/StickyNotification';
import LandingHeader from '@/components/landing/LandingHeader';
import HeroSection from '@/components/landing/HeroSection';
import DemoSection from '@/components/landing/DemoSection';
import FeaturesSection from '@/components/landing/FeaturesSection';
import HowItWorksSection from '@/components/landing/HowItWorksSection';
import BenefitsSection from '@/components/landing/BenefitsSection';
import EmailSignupSection from '@/components/landing/EmailSignupSection';
import LandingFooter from '@/components/landing/LandingFooter';

const LandingPage = () => {
  const [currentFeature, setCurrentFeature] = useState(0);
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentFeature((prev) => (prev + 1) % 3);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const handleConfettiTrigger = () => {
    setShowConfetti(true);
  };

  return (
    <div className="min-h-screen bg-hero-gradient">
      <LandingHeader />
      <HeroSection />
      <DemoSection onConfettiTrigger={handleConfettiTrigger} />
      <AppPreviewMockups />
      <DemandIndicatorsSection />
      <FeaturesSection currentFeature={currentFeature} />
      <HowItWorksSection />
      <BenefitsSection />
      <EmailSignupSection />
      <LandingFooter />

      <ConfettiEffect
        trigger={showConfetti}
        type="complete"
        onComplete={() => setShowConfetti(false)}
      />
      
      <StickyNotification />
    </div>
  );
};

export default LandingPage;
